import { InputAdornment, IconButton, TextField } from '@material-ui/core';
import { Close, Search } from '@material-ui/icons';

interface SearchBarProps {
  label: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClear?: () => void;
}

function SearchBar({ label, onChange, value, onClear }: SearchBarProps): JSX.Element {
  return (
    <div className="search-container">
      <TextField
        id="search"
        name="searchTerm"
        label={label}
        variant="outlined"
        value={value}
        onChange={onChange}
        margin="dense"
        fullWidth
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search color="action" />
            </InputAdornment>
          ),
          endAdornment:
            value && onClear ? (
              <InputAdornment position="end">
                <IconButton size="small" aria-label="clear search" onClick={onClear}>
                  <Close color="action" fontSize="small" />
                </IconButton>
              </InputAdornment>
            ) : null,
          style: {
            borderRadius: '10px',
            backgroundColor: '#fff',
          },
        }}
      />
    </div>
  );
}

export default SearchBar;
